(function($) {

	'use strict'

	var init = function() {
		$('.js-menu-toggle').click((event) => {
			toggleMenu()
		})
		stickyMenu(window, document)
		
        mobileLang()
	}

	var toggleMenu = (buttonEl) => {

		// Same for popup-search
		if(!$('body').hasClass('nav-opened')) {

			if ($(document).height() > $(window).height()) {
				var scrollTop = ($('html').scrollTop()) ? $('html').scrollTop() : $('body').scrollTop(); // Works for Chrome, Firefox, IE...
				$('html').addClass('noscroll').css('top',-scrollTop);
				$('body').addClass('nav-opened');
			}
			
		} else {

			var scrollTop = parseInt($('html').css('top'));
			$('html').removeClass('noscroll');
			$('html,body').scrollTop(-scrollTop);
			$('body').removeClass('nav-opened');

		}
	}

	// MENU STICKY
	/*
	  RequestAnimationFrame Polyfill

	  http://paulirish.com/2011/requestanimationframe-for-smart-animating/
	  http://my.opera.com/emoller/blog/2011/12/20/requestanimationframe-for-smart-er-animating
	  by Erik Möller, fixes from Paul Irish and Tino Zijdel

	  MIT license
	*/
	(function() {
		// Pollyfill remplacant requestAnimationFrame par un setTimeout pour les navigateur le reconnaissant pas
		var lastTime = 0;
		var vendors = ['ms', 'moz', 'webkit', 'o'];
		for(var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
			window.requestAnimationFrame = window[vendors[x]+'RequestAnimationFrame'];
			window.cancelAnimationFrame = window[vendors[x]+'CancelAnimationFrame'] || window[vendors[x]+'CancelRequestAnimationFrame'];
		}

		if ( ! window.requestAnimationFrame ) {
			window.requestAnimationFrame = function(callback, element) {
				var currTime = new Date().getTime();
				var timeToCall = Math.max(0, 16 - (currTime - lastTime));
				var id = window.setTimeout(function() { callback(currTime + timeToCall); }, 
					timeToCall);
				lastTime = currTime + timeToCall;
				return id;
			};
		}

		if ( ! window.cancelAnimationFrame ) {
			window.cancelAnimationFrame = function(id) {
				clearTimeout(id);
			};
		}
	}());

	var stickyMenu = function(w, d, undefined) {
		var el_html = d.documentElement,
			el_body = d.getElementsByTagName("body")[0],
			stickyMenu = d.querySelector(".js-sticky-menu"),

		menuIsStuck = function() {
			var wScrollTop = w.pageYOffset || el_body.wScrollTop,
			regexp = /(nav\-is\-stuck)/i,
			regexpBetween = /(nav\-is\-invisible)/i,
			classFound = el_body.className.match(regexp),
			classFoundBetween = el_body.className.match(regexpBetween),
			navHeight = stickyMenu.offsetHeight,
			bodyRect = el_body.getBoundingClientRect();

			if(window.innerWidth < 800) {
				var scrollValue = 90;
			} else {
				var scrollValue = 150;
			}

			if(wScrollTop >= navHeight && wScrollTop <= scrollValue && !classFoundBetween) {
				el_body.className = el_body.className + ' nav-is-invisible';
			} else if(wScrollTop < navHeight || wScrollTop > scrollValue) {
				el_body.className = el_body.className.replace(regexpBetween, '');
			}

			if(wScrollTop > scrollValue && !classFound) {
				el_body.className = el_body.className + ' nav-is-stuck';
				el_body.style.paddingTop = navHeight + 'px';
			}

			if(wScrollTop < scrollValue && classFound) {
				el_body.className = el_body.className.replace(regexp, '');
				el_body.style.paddingTop = '0';
			}

			return wScrollTop;
		},

		onScrolling = function() {
			var wScrollTop = menuIsStuck();
			var windowHeight = $(window).height();
			var gap =  windowHeight - 500;
		};

		// On scroll
		w.addEventListener('scroll', function() {
			w.requestAnimationFrame(onScrolling);
		});

	};

	var mobileLang = function() {

		$(window).on('resize', function() {
			if($(window).width() < 975) {
				$('.lang__switcher').off('click')
				$('.lang__switcher').on('click', function() {
					$(this).toggleClass('active');
					$('.lang').toggleClass('active');
				});
				$('.lang__switcher').find('a').on('click', function(e) {
					e.stopPropagation();
				})
			}
		}).resize()
		
	}

	$(document).ready(function() {
		init()
	})

})(jQuery)
